import React, { useState } from "react";
import styles from "./index.module.scss";

interface EmptyProps {
  img: string;
  text: string;
}

const HomeChild: React.FC<EmptyProps> = ({ img, text }) => {
  return (
    <>
      <div className={styles["order-none"]}>
        <img src={img} alt="" />
        <span className={styles["order-none-text"]}>{text}</span>
      </div>
    </>
  );
};

export default HomeChild;
